import {
  MenuOutlined,
  NotificationsActiveOutlined,
  NotificationsOutlined,

} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { Sidebar } from "@components/Sidebar";
import LogoWhite from "../assets/images/LogoWhite.png";
import SPM_Primary from "../assets/images/SPM_Primary.png";
// import LogoDark from "../assets/images/logo.png";
import { Footer } from "@components/Footer";
// import { logoutUser } from "../store/slices/authSlice.ts";
import { ImageWithSkeleton } from "@components/ImageWithFallback";
import { useScrollContext } from "@contexts/scroll";
import { useGetMeQuery } from "@features/auth/services";
import { useAppSelector } from "@store/hooks";
import { GlobalErrorScreen } from "@features/error/components";
import { ErrorBoundary } from "react-error-boundary";

const Layout = () => {
  const hasGlobalError = useAppSelector(
    (state) => state?.app?.hasGlobalError
  );

  const { contentRef } = useScrollContext();
  const [isCollapse, setIsCollapse] = useState(false)
  const [isSidebarShow, setSideBarShow] = useState(false)

  const handleToggleSideBar = () => {
    setSideBarShow(!isSidebarShow)
  }
  const handleToggleCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  const [isSmallWidth, setIsSmallWidth] = useState(false)
  const user = useAppSelector(state => state.auth.user)
  const hasUnreadNotifications = user?.hasUnreadNotifications


  useGetMeQuery(undefined, { skip: !user?._id, refetchOnFocus: true });
  useEffect(() => {
    const handleResize = () => {
      setIsSmallWidth(window.innerWidth < 600);
    };
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  return (
    <div>
      {isSmallWidth ?
        <div className="min-h-screen flex items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="text-center">
              <div className="mb-6">
                <Link to="/" className="">
                  <img src={SPM_Primary} className="lg:hidden w-32 mx-auto -translate-x-6" />
                </Link>
              </div>
              <p className="text-xl font-bold text-text1 container">
                For Better Experience Download P&M App
              </p>
            </div>
          </div>
        </div>
        :
        <div className='flex h-screen max-w-[2000px] mx-auto overflow-x-hidden'>
          <div
            className={`h-screen duration-300 w-[250px] fixed z-[30] lg:static ${isCollapse ? 'lg:-ml-[250px]' : 'm-0'} ${isSidebarShow ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
          >
            <Sidebar />
          </div>
          <div className={`fixed z-20 w-full h-full left-0 top-0 bg-black bg-opacity-45 lg:hidden ${!isSidebarShow ? "opacity-0 invisible" : "opacity-100 visible"}`} onClick={handleToggleSideBar} ></div>
          <div
            className={` duration-300 ${isCollapse ? "w-full" : "w-full lg:w-[calc(100%_-_250px)]"}`}
          >
            <div className="px-3 md:px-6 py-2 bg-secondary flex items-center">
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-3">
                  <button
                    className="text-white hidden lg:inline-block"
                    onClick={handleToggleCollapse}
                  >
                    <MenuOutlined className="!text-3xl" />
                  </button>
                  <button
                    className="text-white lg:hidden"
                    onClick={handleToggleSideBar}
                  >
                    <MenuOutlined className="!text-3xl" />
                  </button>
                  <img src={LogoWhite} className="lg:hidden w-32 mx-auto" />
                </div>
                <div className="flex items-center gap-6">
                  <div className="flex items-center gap-4 ">

                    <Link
                      to="/admin/notifications"
                      className=" w-9 h-9 rounded-full flex items-center justify-center sm:border-2 border-border1 text-white hover:bg-primary hover:border-primary duration-300 saveBtn relative"
                    >
                      {hasUnreadNotifications ? (
                        <NotificationsActiveOutlined className="!text-lg" />
                      ) : (
                        <NotificationsOutlined className="!text-lg" />
                      )}

                      {hasUnreadNotifications && (
                        <span className="w-3 h-3 cursor-none rounded-full bg-primary absolute -top-0.5 -right-0.5 text-center text-white text-[14px]"></span>
                      )}
                    </Link>

                  </div>

                  <div className="relative">
                    <Link
                      to="/admin/profile"
                      className="border-2 border-[#E8E1F6] rounded-full w-10 h-10 overflow-hidden block"
                    >
                      <ImageWithSkeleton
                        src={user?.profile_img}
                        alt="profile_img"
                        variant="profile"
                        imgClassName="w-full h-full object-cover rounded-full"
                      />
                    </Link>

                  </div>
                </div>
              </div>
            </div>

            <div ref={contentRef} className="h-[calc(100vh_-_93px)] overflow-y-auto pb-5 bg-[#F4F4F4] pt-3 px-3 md:px-6">
              {hasGlobalError ? (
                <GlobalErrorScreen />
              ) : import.meta.env.PROD ? (
                <ErrorBoundary FallbackComponent={GlobalErrorScreen}>
                  <Outlet />
                </ErrorBoundary>
              ) : (
                <Outlet />
              )}
            </div>
            <Footer />
          </div>
        </div>
      }
    </div>
  );
};

export default Layout;
